import type { MessageValue, Messages } from "./catalog";

export type MessageParams = Record<string, string | number>;

export type Translate = (text: string, params?: MessageParams) => string;

const PLACEHOLDER = /\{(\w+)\}/g;

function pick(value: MessageValue, count: number | undefined, rules: Intl.PluralRules): string {
  if (typeof value === "string") return value;
  if (count === undefined) return value.other;
  return value[rules.select(count)] ?? value.other;
}

export function createTranslator(intlLocale: string, messages: Messages, fallback: Messages): Translate {
  const rules = new Intl.PluralRules(intlLocale);
  const numbers = new Intl.NumberFormat(intlLocale);
  return (text, params) => {
    const count = typeof params?.count === "number" ? params.count : undefined;
    const chosen = pick(messages[text] ?? fallback[text] ?? text, count, rules);
    if (!params) return chosen;
    return chosen.replace(PLACEHOLDER, (match, name: string) => {
      const value = params[name];
      if (value === undefined) return match;
      return typeof value === "number" ? numbers.format(value) : value;
    });
  };
}
